import { PlannerValidation, ProductType } from '@inter-ikea-storageone/range';
// Validation rule to not add another box or mat to a drawer if it already contains one
export class BoxAndMatsPlacementValidation extends PlannerValidation {
    constructor(coreApi) {
        super(coreApi, 'BoxAndMatsPlacementValidation');
        this.coreApi = coreApi;
    }
    validateCurrentState() {
        return this.validationOK();
    }
    validateSnap(snapActionCandidate) {
        const entity = snapActionCandidate.guestRoot;
        if (this.coreApi.entities.isOneOfProductTypes(entity, [
            ProductType.PAX_DRAWER_BOX_ASM,
            ProductType.PAX_DRAWER_MAT
        ])) {
            const currentAccessory = this.coreApi.entities.findDescendantWithOneOfProductTypes(snapActionCandidate.host, [ProductType.PAX_DRAWER_MAT, ProductType.PAX_DRAWER_BOX_ASM]);
            if (currentAccessory?.id === entity.id) {
                // This handles re-snapping same accessory (e.g. when adding interior suggestions)
                return this.validationOK();
            }
            return currentAccessory
                ? this.validationFail('Target already has accessories')
                : this.validationOK();
        }
        return this.validationOK();
    }
}
//# sourceMappingURL=BoxAndMatsPlacementValidation.js.map